import React from 'react';
import { CreditCard, Building, FileText, Library } from 'lucide-react';

const ClaimParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  courtTypes,
  claimTypes,
  disputeCategories
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Сумма иска */}
      <div>
        <label htmlFor="claimAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <CreditCard className="w-4 h-4 mr-2 text-indigo-500" />
          Сумма иска
        </label>
        <input
          type="text"
          id="claimAmount"
          name="claimAmount"
          value={formData.claimAmount}
          onChange={handleInputChange}
          className={`form-input w-full ${errors.claimAmount ? 'input-error' : ''}`}
          placeholder="Введите сумму иска"
        />
        {errors.claimAmount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.claimAmount}
          </p>
        )}
      </div>

      {/* Тип суда */}
      <div>
        <label htmlFor="courtType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Library className="w-4 h-4 mr-2 text-indigo-500" />
          Тип суда
        </label>
        <select
          id="courtType"
          name="courtType"
          value={formData.courtType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.courtType ? 'input-error' : ''}`}
        >
          {courtTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.courtType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.courtType}
          </p>
        )}
      </div>

      {/* Тип иска */}
      <div>
        <label htmlFor="claimType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <FileText className="w-4 h-4 mr-2 text-indigo-500" />
          Тип иска
        </label>
        <select
          id="claimType"
          name="claimType"
          value={formData.claimType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.claimType ? 'input-error' : ''}`}
        >
          {claimTypes
            .filter(type => !(formData.courtType === 'civil' && type.id === 'bankruptcy')) // Фильтрация несовместимых типов
            .map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))
          }
        </select>
        {errors.claimType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.claimType}
          </p>
        )}
      </div>

      {/* Категория спора */}
      <div>
        <label htmlFor="disputeCategory" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Категория спора
        </label>
        <select
          id="disputeCategory"
          name="disputeCategory"
          value={formData.disputeCategory}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.disputeCategory ? 'input-error' : ''}`}
        >
          {disputeCategories.map((category) => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
        </select>
        {errors.disputeCategory && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.disputeCategory}
          </p>
        )}
      </div>

      {/* Статус истца */}
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <Building className="w-4 h-4 mr-2 text-indigo-500" />
          Статус истца
        </label>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="plaintiffStatus"
              value="company"
              checked={formData.plaintiffStatus === 'company'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Юридическое лицо
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="plaintiffStatus"
              value="individual"
              checked={formData.plaintiffStatus === 'individual'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Физическое лицо
            </span>
          </label>
          <label className="inline-flex items-center">
            <input
              type="radio"
              name="plaintiffStatus"
              value="entrepreneur"
              checked={formData.plaintiffStatus === 'entrepreneur'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              ИП
            </span>
          </label>
        </div>
        {errors.plaintiffStatus && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.plaintiffStatus}
          </p>
        )}
      </div>

      {/* Количество ответчиков */}
      <div>
        <label htmlFor="defendantCount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Количество ответчиков
        </label>
        <input
          type="number"
          id="defendantCount"
          name="defendantCount"
          value={formData.defendantCount}
          onChange={handleInputChange}
          min="1"
          max="100"
          className={`form-input w-full ${errors.defendantCount ? 'input-error' : ''}`}
          placeholder="Укажите количество"
        />
        {errors.defendantCount && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.defendantCount}
          </p>
        )}
      </div>
    </div>
  );
};

export default ClaimParametersSection;